import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import type { DialogVariant } from '@/types/dialog';

interface State {
	open: boolean;
	variant: DialogVariant;
	title?: string;
	description?: string | React.ReactNode;
	confirmText?: string;
	cancelText?: string;
	isLoading?: boolean;
}

interface Action {
	onOpenChange: (open: boolean) => void;
	setStore: (key: keyof State, data: State[typeof key]) => void;
	onConfirm?: () => void | Promise<void>;
	onCancel?: () => void | Promise<void>;
	setAction: (
		action: 'onConfirm' | 'onCancel',
		act: () => Promise<void> | void
	) => void;
}

export const useDialogStore = create<State & Action>()(
	devtools(
		immer((set) => ({
			variant: 'success',
			open: false,
			setStore: (key, data) => set({ [key]: data }),
			onOpenChange: (open) => set({ open }),
			setAction: (action, act) => set({ [action]: act })
		}))
	)
);
